// Purchase context bridge and JS delivery of confirmed cart additions.
import { getModatechSessionKey, initializeModatechSession, waitForModatechSession } from './modatechSession'

export function initializeModatechAnalytics(axios) {
    return initializeModatechSession(axios);
}

const installedClients = new WeakSet();
export function installModatechAnalyticsContext(axios) {
    if (installedClients.has(axios)) { return; }
    installedClients.add(axios);
    function sendCart(response) {
        try {
            const config = response.config;
            const target = new URL(config.url, config.baseURL);
            if (target.origin !== new URL(config.baseURL).origin
                || target.pathname !== '/api/basket/add/'
                || (config.method || '').toLowerCase() !== 'post') { return response; }
            const raw = response.headers && response.headers['x-modatech-cart'];
            if (!raw) { return response; }
            const event = JSON.parse(raw);
            if (!event.apiKey || !Array.isArray(event.offers)) { return response; }
            const snapshot = config.modatechAnalyticsContext;
            const key = snapshot ? snapshot.sessionKey : getModatechSessionKey();
            const width = window.innerWidth || document.documentElement.clientWidth;
            event.offers.forEach(offer => {
                if (!/^[1-9][0-9]*$/.test(String(offer))) { return; }
                const body = new URLSearchParams({event_name: 'add_to_cart', fetch_field: 'yml_id',
                    fetch_id: String(offer), user_id: event.userId || null, version: 7,
                    session_key: key, device_type: snapshot ? snapshot.deviceType : (width < 768 ? 'Mobile' : (width < 1024 ? 'Tablet' : 'Desktop')),
                    stat_url: 'https://stat.modatech.ru/', api_key: event.apiKey});
                try {
                    window.fetch('https://stat.modatech.ru/', {method: 'POST', body,
                        keepalive: true, credentials: 'omit'}).catch(() => {});
                } catch (error) {}
            });
        } catch (error) {}
        return response;
    }
    axios.interceptors.response.use(sendCart, error => {
        if (error.response) { sendCart(error.response); }
        return Promise.reject(error);
    });
    axios.interceptors.request.use(async function (config) {
        try {
            const target = new URL(config.url, config.baseURL);
            const base = new URL(config.baseURL);
            if (target.origin !== base.origin || (config.method || '').toLowerCase() !== 'post'
                || !/^\/api\/(basket\/add|order|catalog\/oneclick)\/$/.test(target.pathname)) {
                return config;
            }
            if (!config.modatechAnalyticsContext) { await waitForModatechSession(); }
            const snapshot = config.modatechAnalyticsContext;
            const key = snapshot ? snapshot.sessionKey : getModatechSessionKey();
            const width = window.innerWidth || document.documentElement.clientWidth;
            const context = {
                modatech_session_key: key || '',
                modatech_device_type: width < 768 ? 'Mobile' : (width < 1024 ? 'Tablet' : 'Desktop')
            };
            config.modatechAnalyticsContext = {sessionKey: key, deviceType: context.modatech_device_type};
            if (config.data instanceof FormData || config.data instanceof URLSearchParams) {
                Object.keys(context).forEach(name => config.data.set(name, context[name]));
            } else if (config.data && typeof config.data === 'object') {
                config.data = Object.assign({}, config.data, context);
            }
        } catch (error) {
            // Context failures must never reject cart or checkout requests.
        }
        return config;
    });
}
